<template>
  <div style="display: flex; flex-direction: column;justify-content: space-between;  height: 100%;">
    <div>
      <!-- 訂單列表 -->
      <FinalOrderListPartial :bookings="detailedBookingList" :calculateOrder="calculateOrder" :summary="summaryBooking" :subtotal="subTotal" :activeNames="['1']" />
      <!-- 訂單計算 -->
      <CalculatedOrderListPartial
        :price-adjustments="priceAdjustments"
        :addon-items="addonItems"
        :subtotal="subTotal"
        :stay-nights="stayNights"
        :mode="'live'"
        @update-total="$emit('update-total', $event)"
      />
    </div>
    <div style="display: flex;flex-direction: column;">
      <el-button @click="openEditor('addon')" style="border-radius: 8px; margin-top: 24px;">
        加購商品編輯
      </el-button>
      <el-button @click="openEditor('price')" style="border-radius: 8px; margin-top: 8px;">
        價格編輯與折扣
      </el-button>
    </div>

    <!-- 計算器 -->
    <CalculatorOrderPartial v-model="isOpenCalculator" :editor-mode="editorMode" @update-total="handleCalculatorUpdateTotal" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import CalculatedOrderListPartial from './CalculatedOrderListPartial.vue'
import CalculatorOrderPartial from './CalculatorOrderPartial.vue'
import FinalOrderListPartial from './FinalOrderListPartial.vue'

export default {
  name: 'FinalOrderInfoPartial',
  components: {
    CalculatedOrderListPartial,
    CalculatorOrderPartial,
    FinalOrderListPartial,
  },
  data() {
    return {
      isOpenCalculator: false,
      editorMode: 'price',
    }
  },
  computed: {
    ...mapGetters('hotel/order', ['detailedBookingList', 'calculateOrder', 'summaryBooking', 'subTotal', 'priceAdjustments', 'addonItems']),
    stayNights() {
      const n = Number(this.summaryBooking?.nights)
      return Number.isFinite(n) && n > 0 ? n : 1
    },
  },
  methods: {
    openEditor(mode) {
      this.editorMode = mode
      this.isOpenCalculator = true
    },
    handleCalculatorUpdateTotal(val) {
      if (!this.isOpenCalculator) return
      this.$emit('update-total', val)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-collapse-item__arrow {
  font-size: 26px;
  font-weight: 900;
}
::v-deep .el-collapse-item__header {
  height: 80px;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px;
}

::v-deep .el-button + .el-button {
  margin-left: 0px;
}
</style>
